module.exports = __webpack_public_path__ + "static/img/logo-right.4725af7.png";